import { fetcherReactQuery } from '../../services/api/fetcher'
import { useQuery } from 'react-query'
const fetch = async (api) => {
    try{
        const response = await fetcherReactQuery(api ? api : null)
        return response.data
    }catch(err)
    {
        console.log(err.message)
    }
    
}
const useEmployeeSearch = (user) => {
    return useQuery([`/api/employee/${user}`], fetch)
}
export default useEmployeeSearch